module.exports = __webpack_public_path__ + "fonts/iconfont.e58ae58.ttf";